export class JpgOrPngConversionRequest {
  file_url!: string;
  conversion_type!: string;
}
